"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IFrameModal = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const styled_1 = __importDefault(require("../../styles/styled"));
const buttons_1 = require("../buttons");
const layout_1 = require("../layout");
const modal_1 = require("../modal/modal");
const typography_1 = require("../typography");
const IFrameModal = ({ className, isOpen, onClose, onOpen, src, submit, submitText, }) => {
    return ((0, jsx_runtime_1.jsxs)(modal_1.Modal, Object.assign({ className: className, contentStyle: className ? null : { width: '95vw' }, isOpen: isOpen, onClose: () => onClose(), onOpen: onOpen, styleOverride: {
            card: {
                height: '95vh',
            },
        } }, { children: [(0, jsx_runtime_1.jsx)(typography_1.AppText, Object.assign({ as: "h1", size: "xxlarge", bold: true }, { children: "Survey" })), (0, jsx_runtime_1.jsx)(SurveyFormWrap, { children: (0, jsx_runtime_1.jsx)(SurveyIFrame, { "data-testid": "pro-survey-iframe", src: src }) }), (0, jsx_runtime_1.jsx)(Footer, { children: (0, jsx_runtime_1.jsx)(buttons_1.Button, Object.assign({ onClick: submit !== null && submit !== void 0 ? submit : onClose }, { children: submitText !== null && submitText !== void 0 ? submitText : 'Close' })) })] })));
};
exports.IFrameModal = IFrameModal;
exports.IFrameModal.displayName = 'IFrameModal';
const Footer = (0, styled_1.default)(layout_1.Row)({
    justifyContent: 'flex-end',
    marginTop: '-45px',
});
const SurveyFormWrap = styled_1.default.div({
    paddingRight: '24px',
    width: '100%',
    height: '95%',
    overflow: 'hidden',
});
const SurveyIFrame = styled_1.default.iframe({
    width: '100%',
    height: '70vh',
    overflow: 'hidden',
});
//# sourceMappingURL=i_frame_modal.js.map